import { Navigate, useLocation, useParams } from 'react-router-dom';
import type {
  AgentValue,
  RequestTypeKey,
} from '@/constants/Systemkey/request-type';
import { buildLegacyRequestRedirect } from '@/lib/request-routing';
import type { RequestAction } from '@/lib/request-routing';

export default function LegacyRequestRedirect({
  action,
  requestType,
  agent,
}: {
  action: 'list' | 'create' | RequestAction;
  requestType?: RequestTypeKey;
  agent: AgentValue;
}) {
  const location = useLocation();
  const { id } = useParams();
  return (
    <Navigate
      replace
      to={buildLegacyRequestRedirect(
        action,
        requestType,
        agent,
        id,
        new URLSearchParams(location.search),
      )}
      state={location.state}
    />
  );
}
